import { createAction } from '@reduxjs/toolkit';

export const mergeState = createAction('app/mergeState', (state) => ({
  payload: { state },
}));
